import { NativeFieldFilter, CustomFieldFilter } from 'api/dashboard/widget';
import { User } from 'api/models';

export enum AutomationType {
  Crm = 'CRM',
  KeyEvents = 'KEY_EVENTS',
  CustomAutomation = 'CUSTOM_AUTOMATION',
}

export enum AutomationTriggerInterpretation {
  EachFieldChangedAndMatching = 'EACH_FIELD_CHANGED_AND_MATCHING',
  AnyFieldChangedAndAllMatching = 'ANY_FIELD_CHANGED_AND_ALL_MATCHING',
}

export enum AutomationSource {
  NativeIntegration = 'NATIVE_INTEGRATION',
  KeyEvent = 'KEY_EVENT',
  ProjectTemplate = 'PROJECT_TEMPLATE',
  ProjectPhaseTemplate = 'PROJECT_PHASE_TEMPLATE',
  TaskTemplate = 'TASK_TEMPLATE',
  StatusUpdate = 'STATUS_UPDATE',
  Global = 'GLOBAL',
}

export enum AutomationTriggerType {
  ScheduledTrigger = 'SCHEDULED_TRIGGER',
  EventTrigger = 'EVENT_TRIGGER',
  ExternalEventTrigger = 'EXTERNAL_EVENT_TRIGGER',
  DateTrigger = 'DATE_TRIGGER',
}

export interface Automation {
  automationId: number;
  automationName: string;
  order: number;
  createdBy: User;
  automationType: AutomationType;
  triggerInterpretation: AutomationTriggerInterpretation;
  matchingCondition: SimpleSearchFilter;
  triggerCondition: SimpleSearchFilter;
  triggerV2: AutomationTriggerV2;
  actionsV2: AutomationActionsV2[];
  placeholders: AutomationPlaceholder[];
  source: string;
  sourceId: number;
  createdAt: string;
  updatedAt: string;
  accountId: number;
  deleted: boolean;
  enabled: boolean;
  tags: AutomationTags;
  triggerType: AutomationTriggerType;
}

export interface SimpleSearchFilter {
  nativeFields: NativeFieldFilter[];
  customFields: CustomFieldFilter[];
}

export interface AutomationTriggerV2 {
  uuid: string;
  template: string;
  input: any;
}

export interface AutomationActionsV2 {
  uuid: string;
  template: string;
  input: any;
}

export interface AutomationPlaceholder {
  id: string;
  variable: string;
}

export interface AutomationTags {
  tag: string;
  referenceId: number;
  referenceType: string;
  keyEventAutomationType: string;
  fieldId: number;
}
